import { ref, Ref } from 'vue';
import { writeClipboard } from '~/src_common/helpers/clipboard';

// 予約詳細（nuxt_web2 の components/application/ReceiptNoWithCopy.vue）と同じ値。
// 完了画面・予約詳細でコピー結果の示し方（アイコン差し替え）を揃えているため、
// 戻すまでの時間も合わせる。
const COPIED_FEEDBACK_DURATION_MS = 2000;

export interface UseReceiptNumberCopy {
  copied: Ref<boolean>;
  copy: (text: string) => Promise<void>;
}

export function useReceiptNumberCopy(): UseReceiptNumberCopy {
  const copied = ref(false);
  let resetTimeoutId: ReturnType<typeof setTimeout> | undefined;

  const copy = async (text: string): Promise<void> => {
    const succeeded = await writeClipboard(text);
    if (!succeeded) {
      return;
    }
    copied.value = true;
    if (resetTimeoutId !== undefined) {
      clearTimeout(resetTimeoutId);
    }
    resetTimeoutId = setTimeout(() => {
      copied.value = false;
    }, COPIED_FEEDBACK_DURATION_MS);
  };

  return { copied, copy };
}
